var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"release",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.preventDefault();return _vm.onSelect(_vm.url)}}},[_c('div',{staticClass:"iconfont iconbianji border-color font-color"}),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }